module.exports = __webpack_public_path__ + "img/ruihong_swiper_01.35faec83.jpg";